module.exports = __webpack_public_path__ + "img/intelligent02.234004dc.png";